import { useState } from 'react';
import { useToggle } from 'react-use';

import InPersonDestructiveModalLayout from '../InPersonDestructiveModalLayout';
import InPersonModalLabeledCheckBox from '../InPersonModalLabeledCheckBox';
import ModalParticipantSelectBox from '../ModalParticipantSelectBox';
import ModalTextArea from '../ModalTextArea';

interface CancelInPersonSignModalProps {
  isLoading?: boolean;
  inPersonSigners: Array<{ name?: string | null; contact?: string; id: string }>;
  requesterName?: string;
  onClickCancel: () => void;
  onClickConfirm: (param: { participantId: string; reason: string; blockSigners: boolean }) => void;
}

export default function CancelInPersonSignModal({
  isLoading,
  inPersonSigners,
  requesterName,
  onClickCancel,
  onClickConfirm,
}: CancelInPersonSignModalProps) {
  const [reason, setReason] = useState<string>('');
  const [blockSigners, setBlockSigners] = useToggle(false);
  const [isDirty, setIsDirty] = useToggle(false);
  const [selectedInPersonSignerId, setSelectedParticipantId] = useState<string>(
    inPersonSigners[0].id
  );
  const isValidReasonFormat = !!reason && reason.length > 1;

  const handleConfirmClick = () => {
    setIsDirty(true);

    if (isValidReasonFormat) {
      onClickConfirm({
        participantId: selectedInPersonSignerId,
        reason,
        blockSigners,
      });
    }
  };

  return (
    <InPersonDestructiveModalLayout
      confirmButtonLabel="서명 취소하기"
      description="서명을 취소할 경우 더 이상 서명이 진행되지 않습니다."
      extraMessage={
        inPersonSigners.length > 1 ? '서명을 취소할 대면서명자를 선택해 주세요.' : undefined
      }
      isLoading={isLoading}
      title="서명 취소하기"
      onCancel={onClickCancel}
      onConfirm={handleConfirmClick}
    >
      <ModalParticipantSelectBox
        participants={inPersonSigners}
        selectedParticipantId={selectedInPersonSignerId}
        onClick={(id) => setSelectedParticipantId(id)}
      />
      <ModalTextArea
        errorMessage={isValidReasonFormat ? undefined : '취소 사유를 2자 이상 입력해 주세요.'}
        isDirty={isDirty}
        placeholder={`취소 사유를 입력해 주세요.\n입력한 내용은 요청자, 진행자 및 모든 서명자에게 전송됩니다.`}
        value={reason}
        onBlur={() => setIsDirty(true)}
        onChange={(e) => {
          setReason(e.target.value);
          setIsDirty(true);
        }}
      />
      {requesterName && (
        <InPersonModalLabeledCheckBox
          checked={blockSigners}
          label={`취소한 문서는 요청자 ${requesterName}님을 제외한 모든 서명자가 볼 수 없도록 설정합니다.`}
          onChange={(e) => setBlockSigners(e.target.checked)}
        />
      )}
    </InPersonDestructiveModalLayout>
  );
}
